 <template>
  <div class="add-order">
    <el-form ref="form" label-width="150px">
      <el-row class="form-title">基础信息</el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="返优惠产生规则名称">{{detailData.name}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="返优惠产生规则编码">{{detailData.code}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="返优惠有效期">生成后{{detailData.useEffectNum}}个月</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="返优惠计算周期">每月{{detailData.calculationCycle}}号生成返优惠审核单</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="提货单政策类型">
            {{detailData.preferentialType && detailData.preferentialType.map(item => item.name).join(',')}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产生规则有效期">{{(detailData.effectiveStartDate||'').slice(0,10)}} - {{(detailData.effectiveEndDate||'').slice(0,10)}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="状态">{{detailData.statusName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建人">{{detailData.createPerson}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="创建时间">{{detailData.createTime}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提交审核时间">{{detailData.applyVerifyTime}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="审核时间">{{detailData.verifyTime}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作废人">{{detailData.invalidCardNo}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="作废时间">{{detailData.invalidTime}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作废原因">{{detailData.invalidReason}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-card class="form-card" v-for="(rule, ruleIndex) in detailData.rules" :key="ruleIndex">
      <el-row class="form-title">规则{{ruleIndex+1}}</el-row>
      <el-row class="form-top">返优惠规则</el-row>
      <el-table
        :data="rule.conditions"
        ref="conditions"
        style="width: 100%">
        <el-table-column
          label="范围"
          prop="itemName">
          <template slot-scope="scope">{{scope.row.leActualNum}} ＜ = 发运量 ＜ {{scope.row.gtActualNum}}</template>
        </el-table-column>
        <el-table-column
          label="每吨返优惠（元/t）"
          prop="amount">
        </el-table-column>
      </el-table>
      <el-row class="form-top">适用商品</el-row>
      <el-table
        :data="rule.showGoodsList"
        ref="itemInfos"
        style="width: 100%">
        <el-table-column
          label="商品名称"
          prop="itemName">
        </el-table-column>
        <el-table-column
          label="商品编码"
          prop="itemCode">
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="rule.goodsPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="rule.itemInfos ? rule.itemInfos.length : 0"
        :current-page="rule.goodsPageNo"
        background
        @current-change="e => handleCurrentChange(e, ruleIndex)"
        @size-change="e => handleSizeChange(e, ruleIndex)">
      </el-pagination>
    </el-card>
    <el-row>
      <el-button @click="handleClose">返 回</el-button>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'lookRebateRuleCreate',
  components: { },
  data () {
    return {
      id: this.$route.query.id,
      detailData: { rules: [ { conditions: [] } ] }
    }
  },
  computed: {
  },
  mounted () {
    console.log('[ this.$route.query ] >', this.$route.query)
    this.queryDetail()
  },
  methods: {
    ...mapActions(['generatePolicyDetail']),
    queryDetail () {
      this.generatePolicyDetail({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
          this.handleChangePage()
        }
      })
    },
    handleChangePage () {
      this.detailData.rules = this.detailData.rules.map(rule => {
        const goodsPageSize = rule.goodsPageSize || 10
        const goodsPageNo = rule.goodsPageNo || 1
        return {
          ...rule,
          goodsPageSize: goodsPageSize,
          goodsPageNo: goodsPageNo,
          showGoodsList: this.$lodash.cloneDeep(rule.itemInfos).splice(goodsPageSize * (goodsPageNo - 1), goodsPageSize)
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val, index) {
      this.detailData.rules[index].goodsPageSize = val
      this.detailData.rules[index].goodsPageNo = 1
      this.handleChangePage()
    },
    // 分页跳转
    handleCurrentChange (val = 1, index) {
      this.detailData.rules[index].goodsPageNo = val
      this.handleChangePage()
    },
    handleClose () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.add-order{
  .input-width{
    width: 300px;
  }
  .form-item-inline{
    display: inline-block;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 15px;
  }
  .form-top, .form-card{
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .form-limit{
    margin-top: 8px;
  }
  .export-btn{
    float: right;
  }
  .add-star{
    >.el-form-item__label{
      /deep/ &:before{
        content: '*';
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    .btn-add {
      background-color: #A6D458;
    }
    .btn-del {
      background-color: #F46D5E;
    }
    .btn-circle {
      border-radius: 50%;
      color: white;
      padding: 2px;
      cursor: pointer;
      margin: 0 5px;
    }
  }
}
</style>
